import { useAppDispatch, useAppSelector } from "app/hooks"
import { useEffect } from "react"
import {
  generatePath,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom"
import {
  getMealDetails,
  setMealDetails,
  setMealDetailsBackPath,
} from "../mealSlice"
import PATHS from "router/paths"
import { MealType } from "model/food/types"

export const useMealDetails = () => {
  const { id } = useParams()
  const mealDetails = useAppSelector((state) => state.meal.mealDetails)
  const getMealDetailsLoading = useAppSelector(
    (state) => state.meal.getMealDetailsLoading,
  )
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (id && id !== mealDetails?.id) {
      setMealDetails(undefined)
      dispatch(getMealDetails(id))
    }
  }, [id])

  return {
    getMealDetailsLoading,
    mealDetails,
  }
}

export const useSetMealDetails = () => {
  const dispatch = useAppDispatch()

  return (mealDetails: MealType) => {
    dispatch(setMealDetails(mealDetails))
  }
}

export const useMealDetailsOnBack = () => {
  const mealDetailsBackPath = useAppSelector(
    (state) => state.meal.mealDetailsBackPath,
  )
  const navigate = useNavigate()

  return () => navigate(mealDetailsBackPath ?? PATHS.app.root)
}

export const useResetMealDetailsBackPath = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setMealDetailsBackPath(undefined))
  }, [])
}
